import {
    FETCH_ACTIVE_CARD_TYPES,
    FETCH_CARD_TYPE,
    FETCH_CARD_TYPES,
    REMOVE_CARD_TYPES
} from '../actions/types';

const initialState = {
    items: [],
    activeItems: [],
    currentItem: null,
    pagination: { currentPage: 1, total: 0, perPage: 20 }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CARD_TYPES:
            return {
                ...state,
                items: action.payload?.data || [],
                pagination: {
                    currentPage: parseInt(action.payload?.current_page || 1, 10),
                    total: parseInt(action.payload?.total || 0, 10),
                    perPage: parseInt(action.payload?.per_page || 20, 10)
                }
            };
        case FETCH_ACTIVE_CARD_TYPES:
            return { ...state, activeItems: action.payload || [] };
        case FETCH_CARD_TYPE:
            return { ...state, currentItem: action.payload || null };
        case REMOVE_CARD_TYPES:
            return {
                ...state,
                items: state.items.filter(item => !action.payload.includes(item.id))
            };
        default:
            return state;
    }
};
